
eval("define(\'text!orocrmtask/templates/sidebar-widget/assigned-tasks/assigned-tasks-content-view.html\',[],function () { return \'<div class=\"tasks-list-wrapper\"><%= content %></div>\\n\';});\n\n//# sourceURL=/text!orocrmtask/templates/sidebar-widget/assigned-tasks/assigned-tasks-content-view.html");

